import { Modal } from "@material-ui/core";
import VaccinationCodeCard from "../VaccinationCodeCard";

export default function ModalCode({ openModal = false, codigo = "", setOpen }) {
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <VaccinationCodeCard code={codigo} />
    </Modal>
  )
}
